export default "__VITE_ASSET__Dm3rKCdr__"